import { useMutation } from '@tanstack/react-query'
import { Modal, TextArea } from '@viapeople/components'
import { useEffect, useMemo } from 'react'
import { getBodyWithFakeData } from '../../../utils/emailPreview'
import { trpc } from '../../../utils/trpc'
import type { EmailTemplateFormInput } from '../types'

interface EmailPreviewProps {
	isOpen: boolean
	onClose: () => void
	emailTemplateFormInput: EmailTemplateFormInput
}

export const EmailPreview = ({ isOpen, onClose, emailTemplateFormInput }: EmailPreviewProps) => {
	const bodyWithFakeData = useMemo(
		() => getBodyWithFakeData(emailTemplateFormInput.body),
		[emailTemplateFormInput.body],
	)

	const { mutate: wrapForPreview, data: wrappedHtml } = useMutation(
		trpc.admin.emailTemplates.wrapForPreview.mutationOptions(),
	)

	// biome-ignore lint/correctness/useExhaustiveDependencies: wrapForPreview is a new reference each render; including it would cause extra network calls
	useEffect(() => {
		if (isOpen) wrapForPreview({ body: bodyWithFakeData })
	}, [isOpen, bodyWithFakeData])

	return (
		<Modal isOpen={isOpen} title='Email preview' onClose={onClose} fullScreen>
			<div>
				<TextArea label='Subject' defaultValue={emailTemplateFormInput.subject} disabled rows={1} />
			</div>
			<div className='mt-4 border rounded overflow-hidden' style={{ height: '70vh' }}>
				{wrappedHtml ? (
					<iframe srcDoc={wrappedHtml} title='Email preview' className='w-full h-full' sandbox='' />
				) : (
					<div className='w-full h-full flex items-center justify-center text-gray-400'>Loading preview...</div>
				)}
			</div>
		</Modal>
	)
}
